import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AnimationHackEffect from './animation_hack.js';

const AnimationLink = ({targetId, to, dataValue, faIcon, onMouseEnter, onMouseLeave, isExternal  }) => {
    const [isAnimating, setIsAnimating] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
        setIsAnimating(true);
        if (onMouseEnter) {
          onMouseEnter();
        }
    };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

    if (isExternal) {
        return (
            <div className='papercactus__socials-social_link'
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <a
                    href={to}
                    className='papercactus__socials-social_icon'
                >
                    <i className={faIcon}></i>
                    <div id={targetId} className="text-wrapper">
                        {dataValue}
                        <AnimationHackEffect
                            targetElementId={targetId}
                            dataValue={dataValue}
                            isAnimating={isAnimating}
                            setIsAnimating={setIsAnimating}
                        />
                    </div>
                </a>
            </div>
        );
    }

    return (
        <div className='papercactus__socials-social_link'
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <Link
                href={to}
                className='papercactus__socials-social_icon'
            >
                <i className={faIcon}></i>
                <div id={targetId} className="text-wrapper">
                    {dataValue}
                    <AnimationHackEffect
                        targetElementId={targetId}
                        dataValue={dataValue}
                        isAnimating={isAnimating}
                        setIsAnimating={setIsAnimating}
                    />
                </div>
            </Link>
        </div>
    );
};

export default AnimationLink;